import { useState } from "react";
import { api } from "../../../../services";
import { showError } from "../../../../services/notification";


export const useFetchMyLocation = (onChange, value) => {
  const [isFetchingLocation, setIsFetchingLocation] = useState(false)

  const handleGeolocationError = (error: GeolocationPositionError) => {
    setIsFetchingLocation(false);

    switch (error.code) {
      case error.PERMISSION_DENIED:
        showError("Potrebna je dozvola za pristup lokaciji uređaja.");
        break;
      case error.POSITION_UNAVAILABLE:
        showError("Informacije o lokaciji nisu dostupne.");
        break;
      default:
        showError("Greška pri dohvaćanju lokacije");
    }
  }


  const handleFetchMyLocationClick = () => {
    if (!navigator.geolocation) {
      showError("Geolokacija nije podržana u vašem pregledniku");
      return;
    }

    setIsFetchingLocation(true)

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const response = await api.Location.findByCoordinates({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          },
            (error) => {
              const message = error.status === 404 ? "Pronađena lokacija nije u Hrvatskoj." : "Greška pri dohvaćanju lokacije."
              showError(message);
            }
          )

          setIsFetchingLocation(false);

          onChange({
            ...value,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            countryId: response.countryId,
            countyId: response.countyId,
            cityId: response.cityId,
            settlementId: response.settlementId,
          })
        } catch (error) { }
      },
      handleGeolocationError,
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };


  return {
    handleFetchMyLocationClick,
    isFetchingLocation,
  }

}


// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/hooks/useFetchMyLocation.ts